require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./matangi-gowrishankar.json") })
        }
      }, "path---matangi-gowrishankar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---matangi-gowrishankar!./.cache/json/matangi-gowrishankar.json
// module id = 648
// module chunks = 231608221292675